"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/helpers/index");
var _schema = _interopRequireDefault(require("./schema"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Reducer = new _index.ReducerHelper({
  singular: "invitation"
}, null, {
  schema: _schema.default
});
const reducer = (state, action) => {
  return Reducer.reduce(state, action);
};
var _default = exports.default = reducer;
module.exports = exports.default;